import { useMemo } from "react";

import { observable } from "shared/utilities";

export function useObservable<T extends object>(entry: T) {
    return useMemo(() => observable(entry), []); // eslint-disable-line
}
